// Global runner search: "/" focuses it from anywhere; Enter opens the first
// match, Esc clears.

import clsx from "clsx";
import { forwardRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IconSearch } from "../../components/Icons";
import { Pills, statusPills } from "../components/ui";
import s from "./Search.module.css";
import { useRunnerSearch } from "./useRunnerSearch";

export const Search = forwardRef<HTMLInputElement>(function Search(_props, ref) {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const { results, searching } = useRunnerSearch(q);
  const navigate = useNavigate();
  const go = (id: string) => {
    setQ("");
    setOpen(false);
    navigate(`/runners/${encodeURIComponent(id)}`);
  };
  return (
    <div className={s.wrap}>
      <div className={clsx("input-shell", s.shell)}>
        <IconSearch size={15} className={s.icon} />
        <input
          ref={ref}
          className={s.input}
          value={q}
          placeholder="Find a runner — email, name or id"
          aria-label="Find a runner"
          onChange={(e) => {
            setQ(e.target.value);
            setOpen(true);
          }}
          onFocus={() => setOpen(true)}
          onBlur={() => window.setTimeout(() => setOpen(false), 120)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && results[0]) go(results[0].id);
            if (e.key === "Escape") {
              setQ("");
              e.currentTarget.blur();
            }
          }}
        />
        <span className={clsx("t-mono-xs ink-mute", s.key)}>/</span>
      </div>
      {open && q.trim() !== "" && (
        <div className={s.dropdown} role="listbox">
          {results.map((r, i) => (
            <button key={r.id} className={clsx(s.result, i === 0 && s.resultOn)} onMouseDown={() => go(r.id)} role="option" aria-selected={i === 0}>
              <span className={s.resultText}>
                <span className={clsx("t-label", s.ellipsis)}>{r.name}</span>
                <span className={clsx("t-mono-xs ink-mute", s.ellipsis)}>
                  {r.email} · {r.id}
                </span>
              </span>
              <Pills pills={statusPills(r)} />
            </button>
          ))}
          {!searching && results.length === 0 && <div className={clsx("t-body-sm ink-mute", s.none)}>No runner matches “{q.trim()}”.</div>}
        </div>
      )}
    </div>
  );
});
